import React, { Component } from 'react';
import {
  TextInput,
  Button,
  Table,
  TableContainer,
  CodeSnippetSkeleton,
  TableBody,
  Loading,
  InlineLoading,
} from 'carbon-components-react';
import '../../scss/custom.scss';
import Save16 from '@carbon/icons-react/lib/save/20';
import SimpleReactValidator from 'simple-react-validator';
import moment from 'moment';
import { Information16 } from '@carbon/icons-react';
import { api } from '../../helpers/api/api';
import { showNotification } from '../../helpers/notification/BaseNotification';
import { getError, entitiesLabels, apioperation, getSuccess } from '../../helpers/Constants';
import PageBreadCrumb from '../../helpers/PageBreadCrumb';
import { AppContext } from '../../helpers/context/AppContext';
import { IsEditable } from '../../helpers/authorization/Policies';
import { HistoryTable } from '../../helpers/HistoryTable';
import { WarningModal } from '../common/WarningModal';
import { ConfirmAlertCustom } from '../../helpers/ConfirmAlertCustom';
import ReportRepository from '../../helpers/api/ReportRepository';

export default class AssetIntegrity extends Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator();
    this.geqValidator = {
      message: 'The value must be greater than or equal to zero',
      rule: (val, params, validator) => {
        return +val >= 0;
      },
    };

    this.assetIntegrityFormModel = [
      { label: 'N° of VSC (vessel safety case issued or updated)', fieldRef: 'vsc' },
      { label: 'N° of SCEq (Safety Critical Equipment)', fieldRef: 'scEq' },
      { label: 'N° of SCC (Safety Critical Competences)', fieldRef: 'scc' },
      { label: 'N° of SCP (Safety Critical Procedures)', fieldRef: 'scp' },
      { label: 'N° of SCEq PS (Performance Standards)', fieldRef: 'scEqPS' },
      { label: 'N° of SCC PS (Performance Standards)', fieldRef: 'sccps' },
      { label: 'N° of SCP PS (Performance Standards)', fieldRef: 'scpps' },
      {
        label: 'N° of SCEq PS ES (Performance Standards with examination scheme)',
        fieldRef: 'scEqPSES',
      },
      {
        label: 'N° of SCC PS ES (Performance Standards with examination scheme)',
        fieldRef: 'sccpses',
      },
      {
        label: 'N° of Overdue actions during VSC  addressing MAEs (Cumulated Value)',
        fieldRef: 'vscActionsOverdue',
      },
      {
        label: 'Total N° of actions during VSC addressing MAEs (Cumulated Value)',
        fieldRef: 'vscActionsRaised',
      },
      {
        label:
          'N° of closed MoC requiring Risk Assessment (closed management of change requiring risk assessment, cumulated value)',
        fieldRef: 'closedMoC',
      },
      {
        label:
          'Total N° of MoC requiring Risk Assessment (total number of management of change requiring risk assessment, cumulated value)',
        fieldRef: 'totalMoC',
      },
      {
        label:
          'N° of Overdue work orders on SCEq, (this data could be received from AMOS (3S or HSAF) or manually inputted, cumulated value)',
        fieldRef: 'overdueWOSafetyCriticalEquipment',
      },
      {
        label:
          'Total N° of work orders on SCEq (this data could be received from AMOS (3S or HSAF) or manually inputted, cumulated value)',
        fieldRef: 'plannedWOSafetyCriticalEquipment',
      },
      {
        label:
          'N° of 3S and HSAF SCEq failures, (this data could be received from AMOS (3S or HSAF) or manually inputted)',
        fieldRef: 'scEqFailures',
      },
      { label: 'Total N° of 3S and HSAF SCEq', fieldRef: 'total3Shsaf' }, //new
      {
        label: 'N° of SCC matching with a formalized (mandatory) training',
        fieldRef: 'sccCoveredByMT',
      },
      { label: 'N° of missing or expired mandatory training', fieldRef: 'missingOrExpiredMT' },
      { label: 'N° of total expected mandatory training', fieldRef: 'totalExpectedMT' },
      { label: 'N° of SCC covered by “Competence Assessment', fieldRef: 'sccConveredByCompetence' },
      {
        label: 'N° of SCC involved in competence, assurance and assessment',
        fieldRef: 'numSscInvolved',
      }, //new
      {
        label:
          'N° of Safety Critical Tasks (from VSC) covered by approved and updated procedure or TFC (Task Familiarization Card)',
        fieldRef: 'sctCoveredBySCPOrTFC',
      },
      { label: 'Total N° of Safety Critical Tasks', fieldRef: 'totalSCT' },
      { label: 'N° of updated Emergency Plans', fieldRef: 'updatedEmergencyPlan' },
    ];

    this.state = {
      isDisabled: true,
      isOpenInfo: false,
      isLoadingReport: true,
      report: {},
      assetIntegrity: {},
      isLoadingSubmitted: false,
      isSubmitted: true,
      isWarningModalOpen: false,
      isHistoryModalOpen: false,
      isDeleting: false,
      invalidProperties: {},
    };
  }

  //* ************ HOOKS ************* START
  componentDidMount() {
    this.getReport();
  }
  //* ************ HOOKS ************* END

  //* ************ HISTORY ************* START
  showButtonHistory = () => (
    <Button
      className="action-button-modal"
      kind="secondary"
      renderIcon={Information16}
      onClick={() => this.openModalHistory()}
    >
      History
    </Button>
  );

  openModalHistory = () => {
    this.setState({ isHistoryModalOpen: true });
  };

  closeModalHistory = () => {
    this.setState({ isHistoryModalOpen: false });
  };
  //* ************ HISTORY ************* END

  //* ************ WARNING MODAL ************* START
  handleConfirmSubmit = () => {
    this.setState(
      {
        isWarningModalOpen: false,
      },
      () => this.submitReport(true)
    );
  };

  toggleWarningModal = () => {
    this.setState((prevState) => ({
      isWarningModalOpen: !prevState.isWarningModalOpen,
    }));
  };
  //* ************ WARNING MODAL ************* END

  //* ************ VALIDATIONS ************* START
  updateInvalidProperties = () => {
    if (this.state.assetIntegrity.validator.messagesShown) {
      const invalidProperties = !this.state.assetIntegrity.validator.allValid()
        ? 'error'
        : undefined;
      this.setState({
        invalidProperties,
      });
    }
  };

  onInputChange = (field, e) => {
    const oldAssetIntegrity = this.state.assetIntegrity;
    oldAssetIntegrity[field] = e.target.value;
    this.setState(
      {
        assetIntegrity: oldAssetIntegrity,
      },
      this.updateInvalidProperties
    );
  };
  //* ************ VALIDATIONS ************* END

  //* ************ API ************* START
  getReport = () => {
    ReportRepository.getReportAssetIntegrity(this.props.match.params.idReport)
      .then((response) => {
        response.assetIntegrity.validator = new SimpleReactValidator({
          validators: {
            geq: this.geqValidator,
          },
        });
        this.setState({
          report: response,
          assetIntegrity: response.assetIntegrity,
          isDisabled: !IsEditable(
            'Report',
            'Reporting',
            this.context.user,
            response.idStatus,
            'All'
          ),
        });
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.REPORT, apioperation.GET));
      })
      .finally(() => {
        this.setState({
          isLoadingReport: false,
        });
      });
  };

  submitReport = (fillEmptyFields) => {
    const { validator } = this.state.assetIntegrity;
    if (validator.allValid()) {
      if (
        fillEmptyFields ||
        this.assetIntegrityFormModel.every(
          (sd) =>
            this.state.assetIntegrity[sd.fieldRef] != undefined &&
            this.state.assetIntegrity[sd.fieldRef] !== ''
        )
      ) {
        validator.hideMessages();

        const reportDataList = {};
        this.assetIntegrityFormModel.forEach((f) => {
          reportDataList[f.fieldRef] = this.state.assetIntegrity[f.fieldRef] || 0;
        });

        this.setState({ isSubmitted: false, isLoadingSubmitted: true });
        api
          .put('reports/assetIntegrity/', reportDataList, this.props.match.params.idReport)
          .then(async () => {
            await ReportRepository.updateCachedAssetIntegrity(
              this.props.match.params.idReport,
              reportDataList
            );
            showNotification.success(`${entitiesLabels.SUCCESS}`,getSuccess(entitiesLabels.REPORT, apioperation.PUT));
          })
          .catch((error) => {
            showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.REPORT, apioperation.PUT));
          })
          .finally(() => {
            this.setState(
              {
                isSubmitted: true,
                isLoadingSubmitted: false,
              },
              () => this.getReport(true)
            );
          });
      } else {
        this.toggleWarningModal();
      }
    } else {
      validator.showMessages();
      this.updateInvalidProperties();
    }
  };
  //* ************ API************* END

  //* ************ INFO ************* START
  showDivInfo = () => {
    this.setState((oldState) => ({ isOpenInfo: !oldState.isOpenInfo }));
  };

  divInfo() {
    return (
      <div className=" box--informations-all">
        <div className="bx--row box--information show">
          <div className="bx--col-lg-4 bx--col-md-4 box-information-detail-skeleton">
            <div className="information--itmes">
              <div className="information--color ">Start:</div>
              <div className="notification-module">
                {moment.utc(this.state.report.start).local().format('DD/MM/YYYY')}
              </div>{' '}
            </div>
          </div>
          <div className="bx--col-lg-4 bx--col-md-4 box-information-detail-skeleton">
            <div className="information--itmes">
              <div className="information--color ">End:</div>
              <div className="notification-module">
                {moment.utc(this.state.report.end).local().format('DD/MM/YYYY')}
              </div>{' '}
            </div>
          </div>
          <div className="bx--col-lg-4 bx--col-md-4 box-information-detail-skeleton">
            <div className="information--itmes">
              <div className="information--color ">Compiled by:</div>
              <div className="notification-module">{this.state.report.compiledBy}</div>{' '}
            </div>
          </div>
        </div>
      </div>
    );
  }
  //* ************ INFO ************* END

  showLoading() {
    const show = !this.state.isSubmitted;
    const descr = !this.state.isSubmitted ? 'Saving...' : 'Loading data...';
    return show && <Loading active withOverlay description={descr} />;
  }

  render() {
    if (this.state.assetIntegrity.validator != undefined) {
      this.state.assetIntegrity.validations = this.assetIntegrityFormModel.reduce((acc, cur) => {
        const validationCode = 'geq';
        acc[cur.fieldRef] = this.state.assetIntegrity.validator.message(
          cur.label,
          this.state.assetIntegrity[cur.fieldRef],
          validationCode
        );
        return acc;
      }, {});
    }

    const confirmDelProps = () => ({
      onCloseConfirm: this.onCloseConfirm, // no click
    });

    return (
      <div>
        <PageBreadCrumb
          linkTo={`/reportSummaries/${this.props.match.params.idReportSummary}`}
          linkText="Report Summary"
          titleLeft="Report Asset Integrity"
          titleCenter={this.state.report && `ID: ${this.state.report.progressiveId}`}
          titleRight={this.state.report && this.state.report.status}
          showButtonHistory={this.showButtonHistory()}
        />
        <div className="mainContainer">
          {!this.state.isLoadingReport ? (
            <HistoryTable
              entityId={this.state.report.id}
              isOpenModal={this.state.isHistoryModalOpen}
              onClose={() => this.closeModalHistory()}
            />
          ) : (
            ''
          )}
          {this.state.isLoadingReport ? (
            <CodeSnippetSkeleton type="multi" />
          ) : (
            <>
              <div className="mt-20">{this.divInfo()}</div>
            </>
          )}
          {this.showLoading()}
          <ConfirmAlertCustom {...confirmDelProps()} />
          <div className="bx--grid content full-width mainContainer ">
            <div className="bx--row description-big-title mt-20 description-big-title-custom">
              <div className="bx--col- box-modal-content-costum">
                <div className="box-modal-content-costum-toolbar">
                  <div className="bx--col-lg-12 bx--col-md-12 button--items button-row box-modal-content-costum-title">
                    <Button
                      renderIcon={Save16}
                      className="pull--right"
                      onClick={() => this.submitReport(false)}
                      disabled={this.state.isDisabled || this.state.isLoadingSubmitted}
                    >
                      {this.state.isSubmitted ? (
                        <span>Save</span>
                      ) : (
                        <InlineLoading className="short-loader" />
                      )}
                    </Button>
                  </div>
                </div>
              </div>

              {this.state.invalidProperties != undefined &&
              this.state.assetIntegrity &&
              this.state.assetIntegrity.validator &&
              this.state.assetIntegrity.validator.messagesShown ? (
                <div className="bx--row">
                  <div className="bx--col">
                    <span className="srv-validation-message pull--right">
                      The following report contains erroneous fields
                    </span>
                  </div>
                </div>
              ) : null}

              <TableContainer>
                <Table>
                  <TableBody>
                    {this.assetIntegrityFormModel.map((f) => (
                      <tr className="description-items-list" key={`key_tr_${f.fieldRef}`}>
                        <td> {f.label} </td>
                        <td className="bx--cell-input">
                          <TextInput
                            className="cell--item assetIntegrityValue"
                            key={`key_ti_${f.fieldRef}`}
                            id={`id_ti_${f.fieldRef}`}
                            value={this.state.assetIntegrity[f.fieldRef] || '0'}
                            onChange={(e) => this.onInputChange(f.fieldRef, e)}
                            type="number"
                            min="0"
                            labelText=""
                            disabled={this.state.isDisabled}
                            invalid={
                              this.state.assetIntegrity.validations != undefined
                                ? this.state.assetIntegrity.validations[f.fieldRef] != null
                                : false
                            }
                          />
                          {this.state.assetIntegrity.validations != undefined
                            ? this.state.assetIntegrity.validations[f.fieldRef]
                            : false}
                        </td>
                      </tr>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              {this.state.isWarningModalOpen ? (
                <WarningModal
                  message="Some properties contain empty fields or default values. If you choose to continue, all such fields will be set to zero."
                  onCancel={this.toggleWarningModal}
                  onConfirm={this.handleConfirmSubmit}
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

AssetIntegrity.contextType = AppContext;
